import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
// You can use react-icons for social icons
// npm install react-icons
import { FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-col footer-main">
          <Link to="/" className="footer-logo" data-hover>
            <img src="/logo.png" alt="Apexio Labs" />
            <span>Apexio Labs</span>
          </Link>
          <p>Innovating for a digital-first world.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/apexio_labs/" target="_blank" rel="noopener noreferrer" data-hover><FaInstagram /></a>
            <a href="https://www.linkedin.com/in/mohammed-anjoom-343929229/" target="_blank" rel="noopener noreferrer" data-hover><FaLinkedin /></a>
            <a href="https://wa.me/917736664155" target="_blank" rel="noopener noreferrer" data-hover><FaWhatsapp /></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <Link to="/about" data-hover>About Us</Link>
          <Link to="/services" data-hover>Services</Link>
          <Link to="/careers" data-hover>Careers</Link>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <p>apexiolabs.in@gmail.com</p>
          <p>+91 7736664155</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Apexio Labs. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;